import FormattedMessage from 'I18n/components/FormattedMessage';
import { RightIcon } from 'foundations-assets';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/components/View';
import { StyledLoadingButton } from './NextButton.styles';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NextButton = ({
  autoFocus = false,
  buttonLabel = 'button.next',
  isEnabled = false,
  showIcon = true,
  onClick,
  dataSelenium,
  loading = false
}) => {
  return /*#__PURE__*/_jsx(StyledLoadingButton, {
    disabled: !isEnabled,
    children: /*#__PURE__*/_jsx(LoadingButton, {
      autoFocus: autoFocus,
      disabled: !isEnabled,
      size: 'medium',
      type: 'submit',
      use: 'primary',
      onClick: onClick,
      "data-selenium": dataSelenium,
      loading: loading,
      children: /*#__PURE__*/_jsxs(TFlex, {
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: buttonLabel
          })
        }), showIcon && /*#__PURE__*/_jsx(RightIcon, {
          "data-test-id": "next-button-icon",
          size: "300"
        })]
      })
    })
  });
};